import { styled } from "@mui/material";
import { createShouldForwardPropBlockList, IconButton } from "@pmag/ui-components";

interface StyledIconButtonProps {
    isActive: boolean;
    showInWishList?: boolean;
}

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: createShouldForwardPropBlockList(["isActive", "showInWishList"]),
})<StyledIconButtonProps>(
    ({ theme, isActive, showInWishList }) =>
        !showInWishList && {
            backgroundColor: isActive ? theme.palette.blue._40 : theme.palette.core.grey._30,
            "&:hover": {
                backgroundColor: isActive ? theme.palette.blue._50 : theme.palette.core.grey._40,
            },
        },
);
